import './i18n';
import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';

import { AppRouter } from '@/components/AppRouter';
import { theme } from '@/lib/theme';
import { store } from '@/state/store';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 30_000, retry: 1 },
    },
});

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <div className="Content">
                        <AppRouter />
                    </div>
                </ThemeProvider>
            </Provider>
        </QueryClientProvider>
    );
}
